const firebaseConfig = {
    // apiKey:process.env.REACT_APP_FIREBASE_API_KEY,
    // authDomain:process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    // projectId:process.env.REACT_APP_FIREBASE_PROJECT_ID,
    // storageBucket:process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    // messagingSenderId:process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    // appId:process.env.REACT_APP_FIREBASE_APP_ID,

  apiKey: "AIzaSyB8Mv2GQ_LJk6sgRrJJG9Wvks_hla9i-A4",
  authDomain: "medidocs-1c61b.firebaseapp.com",
  projectId: "medidocs-1c61b",
  storageBucket: "medidocs-1c61b.appspot.com",
  messagingSenderId: "704203825229",
  appId: "1:704203825229:web:327e0dcb492acde37d7c04"
  };
  export default firebaseConfig;